
import React from 'react';
import MapLogo from '../../assets/images/Map-Logo.svg'


const AddressComponent = ({ address }) => {
  const googleMapsUrl = `https://www.google.com/maps/place/CE+Enologica+-+%E1%83%A9%E1%83%98%E1%83%94+%E1%83%94%E1%83%9C%E1%83%9D%E1%83%9A%E1%83%9D%E1%83%AF%E1%83%98%E1%83%99%E1%83%90/@41.6890607,44.8372499,17z/data=!4m6!3m5!1s0x40446f46e55a759d:0xbe9a98bfc623e999!8m2!3d41.6891124!4d44.8357683!16s%2Fg%2F11j6fw4_tl?entry=ttu${encodeURIComponent(address)}`;

  return (
    <div className='mapadress'>
      <img src={MapLogo}/>
      <a href={googleMapsUrl} target="_blank" rel="no">
        {'Tbilisi atskuris#15'}
      </a>
    </div>
  );
};

export default AddressComponent;
